import React, {
  useCallback,
  useEffect,
  useRef,
  Children,
  isValidElement,
  cloneElement,
} from 'react';
import { Box, Typography } from '@mui/material';

import { Spinner } from 'components/Loading/Spinner/Spinner';

import { useInfiniteScrollContainerStyles } from 'components/InfiniteScrollContainer/styles';

const START_LOAD_MORE_END_INDEX = 3;

export const InfiniteScrollContainer = ({
  children,
  items,
  loading,
  hasMore,
  fetchData,
  className = '',
}) => {
  const { classes } = useInfiniteScrollContainerStyles();

  const observer = useRef();

  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchData();
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, fetchData],
  );

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box className={`${classes.infiniteScrollContainer} ${className}`}>
      {Children.map(children, (child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...child.props,
            ref:
              index === items.length - START_LOAD_MORE_END_INDEX
                ? lastItemRef
                : null,
          });
        }

        return child;
      })}
      {loading && !items.length && (
        <Box className={classes.spinnerContainer}>
          <Spinner />
        </Box>
      )}
      {!loading && !items.length && !hasMore && (
        <Typography marginY="auto">No comments</Typography>
      )}
    </Box>
  );
};
